import React from 'react';
import Card from '../../Card';
import Button from '../../Button';

function scoreColor(score, notTested) {
  if (notTested) return '#94a3b8';
  if (score >= 80) return '#16a34a';
  if (score >= 60) return '#2563eb';
  return '#d97706';
}

export default function P3DimensionDetail({
  report, dimensionAnalysis, dimensionIndex,
  wrongCount = 0, onOpenDrawer,
}) {
  const da = dimensionAnalysis || {};
  const dimId = da.dimension_id;
  const dimScore = (report?.core?.dimension_scores || []).find(d => d.dimension_id === dimId);
  const weakKps = Array.isArray(da.weak_knowledge_points) ? da.weak_knowledge_points : [];
  const dimName = dimScore?.dimension_name || `维度 ${dimensionIndex + 1}`;

  return (
    <div data-testid={`report-page-p3-${dimensionIndex}`}>
      <Card style={{ padding: '28px 32px', marginBottom: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 16, gap: 12, flexWrap: 'wrap' }}>
          <h2 style={{ fontSize: 18, margin: 0, minWidth: 0, wordBreak: 'break-word', overflowWrap: 'anywhere' }}>{dimName}</h2>
          {dimScore && !dimScore.not_tested && (
            <span style={{ fontSize: 16, fontWeight: 700, color: scoreColor(dimScore.score), whiteSpace: 'nowrap', flexShrink: 0 }}>
              {dimScore.score} 分
            </span>
          )}
        </div>
        {da.score_interpretation && (
          <p style={{ fontSize: 14, lineHeight: 1.7, color: 'var(--color-text)', margin: 0 }}>
            {da.score_interpretation}
          </p>
        )}
      </Card>

      {weakKps.length > 0 && (
        <Card style={{ padding: '24px 28px', marginBottom: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, gap: 12, flexWrap: 'wrap' }}>
            <h3 style={{ fontSize: 15, fontWeight: 700, margin: 0 }}>知识点短板</h3>
            {wrongCount > 0 && (
              <Button
                variant="secondary"
                onClick={() => onOpenDrawer && onOpenDrawer({ dimensionId: dimId, dimName })}
                data-testid={`report-page-p3-${dimensionIndex}-view-wrongs`}
                style={{ fontSize: 12, padding: '6px 14px' }}
              >
                查看错题（{wrongCount}）
              </Button>
            )}
          </div>
          <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 18 }}>
            {weakKps.map((kp, i) => (
              <li key={i} style={{ paddingLeft: 14, borderLeft: '3px solid #d97706' }}>
                <p style={{ fontSize: 14, fontWeight: 600, margin: '0 0 6px' }}>
                  {kp.name || `知识点 ${i + 1}`}
                </p>
                {kp.evidence && (
                  <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', lineHeight: 1.7, margin: '0 0 6px' }}>
                    {kp.evidence}
                  </p>
                )}
                {kp.improvement && (
                  <p style={{ fontSize: 12, color: 'var(--color-text-muted)', lineHeight: 1.7, margin: 0 }}>
                    建议：{kp.improvement}
                  </p>
                )}
              </li>
            ))}
          </ul>
        </Card>
      )}

      {da.scenario_suggestion && (
        <Card style={{ padding: '20px 28px', marginBottom: 24, borderLeft: '4px solid #16a34a' }}>
          <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 8, color: '#16a34a', letterSpacing: 1 }}>
            结合你的岗位
          </h3>
          <p style={{ fontSize: 13, lineHeight: 1.7, margin: 0 }}>{da.scenario_suggestion}</p>
        </Card>
      )}
    </div>
  );
}
